module.exports = __webpack_public_path__ + "static/media/anchor.732954be.jpg";